import { render, staticRenderFns } from "./StudioStatusVertical.vue?vue&type=template&id=86b64492&scoped=true&"
import script from "./StudioStatusVertical.vue?vue&type=script&lang=js&"
export * from "./StudioStatusVertical.vue?vue&type=script&lang=js&"
import style0 from "./StudioStatusVertical.vue?vue&type=style&index=0&id=86b64492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b64492",
  null
  
)

export default component.exports